import styles from './prices.module.scss';
import { useState } from 'react';
import RightsWrapper from './../../../rights-wrapper/rights-wrapper';
import { useCourseGetRequestHook } from 'libs/webkua-lib/src/lib/requestUtils';
import { ValueFormatterParams } from 'ag-grid-community';
import WebkuaTable from '../../../webkua-table/webkua-table';
import { CreateHeaders, ErrorButton, HeaderSizeEnum, Icon, PrimaryButton, currencyHeader, textHeader } from '@frontend-workspace/react-shared-lib';
import CreateNewPriceDialog from './create-new-price-dialog/create-new-price-dialog';
import DeletePriceDialog from './delete-price-dialog/delete-price-dialog';
import { IPrice } from './../../../_models/price';
import PricesSkeleton from './prices-skeleton';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface PricesProps { }

export function Prices(props: PricesProps) {
  const { t } = useTranslation();
  const { data: prices, isLoading, getData: getPrices }: { data: IPrice[], isLoading: boolean, getData: () => void } = useCourseGetRequestHook(`resource/prices`, []);

  const [isNewPriceOpen, setIsNewPriceOpen] = useState(false);
  const [deletePrice, setDeletePrice] = useState<IPrice | undefined>(undefined);

  const toggleNewPriceOpen = () => setIsNewPriceOpen(!isNewPriceOpen);

  const openDeletePriceDialog = (e: any) => setDeletePrice(e.data);
  const closeDeletePriceDialog = () => setDeletePrice(undefined);

  const deleteRenderer = (params: ValueFormatterParams) => {
    return (
      <ErrorButton
        variant="outlined"
        size='small'
        onClick={() => openDeletePriceDialog(params)}>
        {t('standard.delete')}
      </ErrorButton>
    );
  }

  return (<>
    <RightsWrapper>
      <div className='mb-3'>
        <PrimaryButton
          variant="contained"
          onClick={toggleNewPriceOpen}>
          <Icon className="me-1" fontSize="small">add</Icon>{t('standard.newPrice')}
        </PrimaryButton>
      </div>
    </RightsWrapper>
    {isLoading ? <PricesSkeleton /> :
      <WebkuaTable
        data={prices}
        headers={CreateHeaders([
          currencyHeader("value", t('standard.price'), HeaderSizeEnum.EXTRA_LARGE),
          textHeader("", "", HeaderSizeEnum.MEDIUM, {
            renderer: deleteRenderer,
            cellStyle: { justifyContent: 'right' },
            headerClass: "ag-right-aligned-header"
          })
        ])}
      />}
    {isNewPriceOpen && <CreateNewPriceDialog
      onClose={toggleNewPriceOpen}
      open={!!isNewPriceOpen}
      refreshData={getPrices}
    />}
    {deletePrice && <DeletePriceDialog
      onClose={closeDeletePriceDialog}
      open={!!deletePrice}
      refreshData={getPrices}
      priceId={deletePrice.id}
    />}
  </>);
}

export default Prices;
